import { useEffect } from "react";

export default function useTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} · Feira de Saúde e Bem-Estar 2026` : "Feira de Saúde e Bem-Estar 2026 · Semana da Saúde Mental";
  }, [title]);
}
